<template>
	<div class="drawer">
		<el-drawer
		size="600px"
		title="完成洗美"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<img src="../../../../assets/img/reset.png" class="avatar"/>
			<div style="padding-bottom:40px;">
				<!-- <el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">姓名：</span>
						<span class="value">
							{{curItem.memberName}}
						</span>
					</el-col>
				</el-row> -->
				<el-row style="padding:40px 20px 0 80px;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">更新销售人员：</span>
						<span class="value">
							<el-select v-model="saleManIdList" @change="changeSaleManIdList" multiple filterable placeholder="请选择" size="mini" style="width:210px;margin-bottom:20px;">
								<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
								:value="item._id+','+item.basic_info.nick_name"></el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<div style="height: 40px;width:100%;"></div>
				<div class="btnBox">
					<div class="btnItem" @click="handleClose">取消</div>
					<div class="btnItem submit" @click="submit">确定</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				saleManIdList:[],
				staffList:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.getStaffList();
				console.log(this.curItem)
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submit(){
				if(this.$public.isNull(this.saleManIdList)){
					this.$message({
						message: '请选择更新销售人员',
						type: 'error'
					});
					return ;
				}
				let salesMans = []
				for(let i=0;i<this.saleManIdList.length;i++){
					let arr = this.saleManIdList[i].split(',')
					salesMans.push({"userId": arr[0],"userName": arr[1]})
				}
				let params = {
					"serviceId": this.curItem.washRecordId,
					salesMans:salesMans,
				}
				console.log(params)
				let loading = this.$loading()
				this.$http.post('/api/WashBeauty/Complete', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功！',
							type: 'success'
						});
						this.$emit('submit',{type:'success'})
					}
				})
			},
			// 销售人员
			changeSaleManIdList(){
				console.log(this.saleManIdList)
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/BathStaffList', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
						for(let i=0;i<this.curItem.salesManList.length;i++){
							this.saleManIdList.push(this.curItem.salesManList[i].userId+','+this.curItem.salesManList[i].userName)
						}
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:220px;
				display: block;
				margin:150px auto 80px;
			}
			.label{
				display: inline-block;width:140px;text-align: right;
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
